import * as React from "react";

const Filter: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17">
            <path
                fill="currentColor"
                d="M0 12.25L0 13.75L0.75 13.75L2.5 13.75L2.5 14L2.5 15.5L4 15.5L6 15.5L7.5 15.5L7.5 14L7.5 13.75L15.25 13.75L16 13.75L16 12.25L15.25 12.25L7.5 12.25L7.5 12L7.5 10.5L6 10.5L4 10.5L2.5 10.5L2.5 12L2.5 12.25L0.75 12.25L0 12.25ZM0 7.25L0 8.75L0.75 8.75L8.5 8.75L8.5 9L8.5 10.5L10 10.5L12 10.5L13.5 10.5L13.5 9L13.5 8.75L15.25 8.75L16 8.75L16 7.25L15.25 7.25L13.5 7.25L13.5 7L13.5 5.5L12 5.5L10 5.5L8.5 5.5L8.5 7L8.5 7.25L0.75 7.25L0 7.25ZM3.5 3.75L3.5 4L3.5 5.5L5 5.5L7 5.5L8.5 5.5L8.5 4L8.5 3.75L15.25 3.75L16 3.75L16 2.25L15.25 2.25L8.5 2.25L8.5 2L8.5 0.5L7 0.5L5 0.5L3.5 0.5L3.5 2L3.5 2.25L0.75 2.25L0 2.25L0 3.75L0.75 3.75L3.5 3.75ZM10 9L10 7L12 7L12 9L10 9ZM4 12L6 12L6 14L4 14L4 12ZM5 4L5 2L7 2L7 4L5 4Z"
            />
        </svg>
    );
};

export default React.memo(Filter);
